import AnalyticsVendor from './AnalyticsVendor';

class SWS extends AnalyticsVendor {
  enabled: boolean;

  constructor() {
    super();
    this.enabled = true;
  }

  test() {
    return true;
  }

  identify() {
    return true;
  }

  track(event, eventProperties) {
    if (typeof window !== 'undefined') {
      const data = Object.assign(
        {
          event,
        },
        eventProperties
      );
      window['analytics'].dataLayer.push(data);
    }
  }

  page() {
    return true;
  }
}

export default SWS;
